var map = {
	"./atmire/app/shared/object-detail/my-dspace-result-detail-element/item-detail-preview/item-detail-preview.component": [
		"x0Vt",
		60
	],
	"./custom/app/shared/object-detail/my-dspace-result-detail-element/item-detail-preview/item-detail-preview.component": [
		"j2FE",
		140
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "nivB";
module.exports = webpackAsyncContext;